import * as React from 'react';
import {
    OutlinedInput,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Checkbox,
    TextField,
    Box,
    Typography,
    Tooltip,
    Avatar,
} from '@mui/material';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
        },
    },
};

const getInitials = (fullName) => {
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

function TruncatedTooltip({ children }) {
    const textRef = React.useRef(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [children]);

    return isTruncated ? (
        <Tooltip title={children}>
            <Typography
                ref={textRef}
                noWrap
                sx={{
                    maxWidth: '160px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                    color: '#111',
                    cursor: 'default',
                    fontFamily: 'Manrope'
                }}
            >
                {children}
            </Typography>
        </Tooltip>
    ) : (
        <Typography
            ref={textRef}
            noWrap
            sx={{
                maxWidth: '160px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '14px',
                color: '#111',
                fontFamily: 'Manrope'
            }}
        >
            {children}
        </Typography>
    );
}
export default function SelectDropDowns({
    label = 'Select User',
    options = [],
    selectedValue = '',
    onChange = () => { },
}) {
    const [searchTerm, setSearchTerm] = React.useState('');

    const handleChange = (event) => {
        onChange(event.target.value);
    };

    const filteredOptions = options.filter((opt) =>
        opt.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectedOption = options.find((opt) => opt.name === selectedValue);

    return (


        <FormControl sx={{ m: 0, width: '100%' }}>
            <Select
                id={`${label}-select`}
                value={selectedValue}
                onChange={handleChange}
                displayEmpty
                input={
                    <OutlinedInput
                        sx={{
                            height: 38,
                            borderRadius: '50px',
                            paddingRight: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            fontFamily:'Manrope',
                            fontSize:'14px',


                        }}
                    />
                }
                renderValue={(selected) =>
                    selectedOption ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontFamily:'Manrope' }}>
                            <Typography sx={{fontFamily:'Manrope', fontSize:'14px'}}>{selectedOption.name}</Typography>
                        </Box>
                    ) : (
                        <Typography sx={{ color: '#A0AEC0', fontFamily:'Manrope', fontSize:'14px' }}>
                            {label}
                        </Typography>
                    )
                }
                MenuProps={MenuProps}
                sx={{
                    background: '#fff',
                    borderRadius: '6px',
                    '& .MuiSelect-select': {
                        paddingTop: '8px',
                        paddingBottom: '7px',
                        height: 23,
                        fontSize: '12px',
                        color: '#64748B',
                        fontFamily:'Manrope'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '6px',
                        fontFamily:'Manrope'
                    },
                }}
            >
                {filteredOptions.map((opt) => (
                    <MenuItem key={opt.name} value={opt.name}>
                        <TruncatedTooltip sx={{fontFamily:'Manrope'}}>{opt.name}</TruncatedTooltip>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
